import { addDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiTooltip']} */
const overwrite = {
  defaultProps: {
    PopperProps: addDisablePortal(),
  },
  styleOverrides: {
    tooltip: {
      margin: '0px 10px',
      borderRadius: 4,
      background: 'rgba(30, 32, 38, 0.6)',
    },
  },
}

export const MuiTooltip = overwrite
